import { toast } from 'react-toastify';
import { generalValidationFunction } from '../mle.validation';
import { FORM_ERRORS } from '../mle.constants';
import { isAllErrorFixed } from '../mle.utils';
import { UBO_ACCORDIAN_NAME, uboDeclarationUrls, uboFields } from './constant';

const ERROR_MSG_ADDRESS = 'POA document update is required.';

const validate = (values, props, basicData) => {
    try {

        let errors = {};
        errors[UBO_ACCORDIAN_NAME] = [];
        
        if (!values?.[uboDeclarationUrls.reqname]) {
            let validationObject = {...uboDeclarationUrls};
            validationObject.name = validationObject.reqname;
            errors[uboDeclarationUrls.name] = generalValidationFunction(values, [validationObject])?.[validationObject.name];
            
        }
        let panArrays = [];
        let filteredEditedCategoryIdx = values?.filteredEditedCategoryIdx ?? [];
        
       
        if (values?.[UBO_ACCORDIAN_NAME] && typeof values[UBO_ACCORDIAN_NAME] === 'object' && values[UBO_ACCORDIAN_NAME].length) {
            
            for (let i = 0; i < values[UBO_ACCORDIAN_NAME].length; i++) {
                let panNumber = values[UBO_ACCORDIAN_NAME][i]?.panDetails?.panNumber || '';
                
                // if (panNumber ) {
                //     panArrays.push(values[UBO_ACCORDIAN_NAME][i]?.panDetails?.panNumber)
                // }
                
                const errorData = generalValidationFunction(values[UBO_ACCORDIAN_NAME], uboFields, i);
                if (errorData[i])
                    errors[UBO_ACCORDIAN_NAME].push(errorData[i]);
                else 
                    errors[UBO_ACCORDIAN_NAME].push({});
                
                
                if (filteredEditedCategoryIdx?.toString()?.includes(i)) {
                    errors[UBO_ACCORDIAN_NAME][i].addressFile = ERROR_MSG_ADDRESS;
                } else if(!filteredEditedCategoryIdx?.toString()?.includes(i) && errors[UBO_ACCORDIAN_NAME][i]?.addressFile === ERROR_MSG_ADDRESS) {
                    errors[UBO_ACCORDIAN_NAME][i].addressFile = undefined;
                }
                if (panNumber && panArrays.includes(panNumber)) {
                    if (!errors[UBO_ACCORDIAN_NAME][i].panDetails) {
                        errors[UBO_ACCORDIAN_NAME][i].panDetails = {};
                    }
                    errors[UBO_ACCORDIAN_NAME][i].panDetails.panNumber = 'Pan Number cannot be duplicate.';
                } else if (panNumber){
                    panArrays.push(panNumber);
                }
                
            }
            
            // values?.[UBO_ACCORDIAN_NAME]?.map((item, index) => {
            //     console.log("item validate", item);
            //     errors = generalValidationFunction(values, uboFields, index);    
            // })
        }

        // if (values?.editedDocCategory && Array.isArray(values?.editedDocCategory) && values?.editedDocCategory?.length > 0) {
        //     if (values.editedDocCategory.includes('POA')) {
                
        //     } 
        // }

        
        
        // if (errors.address) delete errors.address;
        if (errors && !isAllErrorFixed(errors)){
            
            // toast.error(FORM_ERRORS);
            // props.stopSubmit(MLE_CREATE_FORM_NAME, errors);
            return errors;
        } else {
            return {};        
            
        }
        
    } catch(e) {
        console.log("e message", e.message);
        return {};
    }

};

export default validate;
 